import React from 'react';
import './SearchBar.scss';
import IconSwitch from '../../IconSwitch';

interface SearchBarProps {
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange }) => {
    return (
        <div className="search-bar">
            <div className="icon-left">
                <IconSwitch name="magnifier" />
            </div>
            <input type="text" placeholder="Search..." value={value} onChange={onChange} />
            <div className="icon-right">
                <IconSwitch name="sort" />
            </div>
        </div>
    );
};

export default SearchBar;
